/**
 * Hide all visible modals when changing route
 *
 * @param root0
 * @param root0.$vfm
 */
export default function ({ $vfm }) {
    $vfm?.hideAll()
}
